// src/lessonRegistry.js

export const lessonLoaders = {
  // I. Liczby i działania
  // 1_12 = Systemy zapisywania liczb
  "1_12_1": () =>
    import("./lessons/Lesson_1_12_1_CyfryRzymskie/Lesson_index"),

  "1_1_1": () =>
    import("./lessons/Lesson_1_1_1_Kolejnosc/Lesson_index"),
  "1_1_2": () =>
    import("./lessons/Lesson_1_1_2_Wartosc/Lesson_index"),
  "1_1_3": () =>
    import("./lessons/Lesson_1_1_3_Zbiory/Lesson_index"),
  "1_1_4": () =>
    import("./lessons/Lesson_1_1_4_Przedzialy/Lesson_index"),
  "1_1_5": () =>
    import("./lessons/Lesson_1_1_5_DzialaniaNaPierwiastkach/Lesson_index"),
  "1_1": () =>
    import("./lessons/Lesson_1_1_Quiz/FinalQuiz"),
    // ✅ 1_2 = Procenty (ładowane z folderów Lesson_1_4_*)
  "1_2_1": () =>
    import("./lessons/Lesson_1_4_1_Obliczanie/Lesson_index"),
  "1_2_2": () =>
    import("./lessons/Lesson_1_4_2_Zmiany/Lesson_index"),
  "1_2_3": () =>
    import("./lessons/Lesson_1_4_3_Porownania/Lesson_index"),
  "1_2_4": () =>
    import("./lessons/Lesson_4_3_3_ProcentSkładany/Lesson_index"),
  "1_2": () =>
    import("./lessons/Lesson_1_4_Quiz/FinalQuiz"),

  // ✅ 1_3 = Teoria liczb (ładowane z folderów Lesson_1_5_*)
  "1_3_1": () =>
    import("./lessons/Lesson_1_5_1_Podzielnosc/Lesson_index"),
  "1_3_2": () =>
    import("./lessons/Lesson_1_5_2_LiczbyPierwsze/Lesson_index"),
  "1_3_3": () =>
    import("./lessons/Lesson_1_5_3_NwdNww/Lesson_index"),
  "1_3": () =>
    import("./lessons/Lesson_1_5_Quiz/FinalQuiz"),

  // ✅ 1_4 = Potęgi i pierwiastki (ładowane z folderów Lesson_1_2_*)
  "1_4_1": () =>
    import("./lessons/Lesson_1_2_1_PotegiNaturalne/Lesson_index"),
  "1_4_2": () =>
    import("./lessons/Lesson_1_2_2_PotegiCalkowite/Lesson_index"),
  "1_4_3": () =>
    import("./lessons/Lesson_1_2_3_PotegiWymiernePierwiastki/Lesson_index"),
  "1_4_4": () =>
    import("./lessons/Lesson_1_2_4_Notacja/Lesson_index"),
  "1_4": () =>
    import("./lessons/Lesson_1_2_Quiz/FinalQuiz"),

  // ✅ 1_5 = Logarytmy (ładowane z folderów Lesson_1_3_*)
  "1_5_1": () =>
    import("./lessons/Lesson_1_3_1_Definicja/Lesson_index"),
  "1_5_2": () =>
    import("./lessons/Lesson_1_3_2_Wlasnosci/Lesson_index"),
  "1_5_3": () =>
    import("./lessons/Lesson_1_3_3_Obliczanie/Lesson_index"),
  "1_5": () =>
    import("./lessons/Lesson_1_3_Quiz/FinalQuiz"),
  "1_6_1": () =>
    import("./lessons/Lesson_1_6_1_Uzupelniajace/Lesson_index"),
  "1_6_2": () =>
    import("./lessons/Lesson_1_6_2_Zamkniete/Lesson_index"),
  "1_6_3": () =>
    import("./lessons/Lesson_1_6_3_Otwarte/Lesson_index"),
  "1_6_4": () =>
    import("./lessons/Lesson_1_6_4_E8Zamkniete/Lesson_index"),
  "1_6_5": () =>
    import("./lessons/Lesson_1_6_5_E8Otwarte/Lesson_index"),

  // 1_7 = Liczby naturalne i dzialania
  "1_7_1": () =>
    import("./lessons/Lesson_1_7_1_DodawanieOdejmowanieNaturalne/Lesson_index"),
  "1_7_2": () =>
    import("./lessons/Lesson_1_7_2_MnozenieNaturalne/Lesson_index"),
  "1_7_3": () =>
    import("./lessons/Lesson_1_7_3_DzielenieNaturalne/Lesson_index"),
  "1_7_4": () =>
    import("./lessons/Lesson_1_1_1_Kolejnosc/Lesson_index"),

  // 1_8 = Dzialania pisemne
  "1_8_1": () =>
    import("./lessons/Lesson_1_8_1_DodawaniePisemne/Lesson_index"),
  "1_8_2": () =>
    import("./lessons/Lesson_1_8_2_OdejmowaniePisemne/Lesson_index"),
  "1_8_3": () =>
    import("./lessons/Lesson_1_8_3_MnozeniePisemne/Lesson_index"),
  "1_8_4": () =>
    import("./lessons/Lesson_1_8_4_DzieleniePisemne/Lesson_index"),

  // 1_9 = Liczby calkowite
  "1_9_1": () =>
    import("./lessons/Lesson_1_9_1_OsLiczbowa/Lesson_index"),
  "1_9_2": () =>
    import("./lessons/Lesson_1_9_2_DodawanieOdejmowanieCalkowite/Lesson_index"),
  "1_9_3": () =>
    import("./lessons/Lesson_1_9_3_MnozenieCalkowite/Lesson_index"),
  "1_9_4": () =>
    import("./lessons/Lesson_1_9_4_DzielenieCalkowite/Lesson_index"),

  // 1_10 = Ulamki zwykle
  "1_10_1": () =>
    import("./lessons/Lesson_1_10_1_SkracanieRozszerzanieUlamkow/Lesson_index"),
  "1_10_2": () =>
    import("./lessons/Lesson_1_10_2_PorownywanieUlamkow/Lesson_index"),
  "1_10_3": () =>
    import("./lessons/Lesson_1_10_3_DodawanieOdejmowanieUlamkow/Lesson_index"),
  "1_10_4": () =>
    import("./lessons/Lesson_1_10_4_MnozenieUlamkow/Lesson_index"),
  "1_10_5": () =>
    import("./lessons/Lesson_1_10_5_DzielenieUlamkow/Lesson_index"),
  "1_10_6": () =>
    import("./lessons/Lesson_1_10_6_LiczbyMieszane/Lesson_index"),
  "1_10_7": () =>
    import("./lessons/Lesson_1_10_7_DzialaniaLaczneWymierne/Lesson_index"),

  // II. Algebra
  "2_1_1": () =>
    import("./lessons/Lesson_2_1_1_Upraszczanie/Lesson_index"),
  "2_1_2": () =>
    import("./lessons/Lesson_2_1_2_WzorySkroconego/Lesson_index"),
  "2_1_3": () =>
    import("./lessons/Lesson_2_1_3_Ulamki/Lesson_index"),
  "2_1_4": () =>
    import("./lessons/Lesson_2_1_4_Wielomiany/Lesson_index"),
  "2_1": () =>
    import("./lessons/Lesson_2_1_Quiz/FinalQuiz"),

  "2_7_1": () =>
    import("./lessons/Lesson_2_7_1_PojecieStopienWartosc/Lesson_index"),
  "2_7_2": () =>
    import("./lessons/Lesson_2_7_2_DzialaniaNaWielomianach/Lesson_index"),
  "2_7_3": () =>
    import("./lessons/Lesson_2_7_3_RozkladNaCzynniki/Lesson_index"),
  "2_7_4": () =>
    import("./lessons/Lesson_2_7_4_RownaniaWielomianowe/Lesson_index"),

  "2_2_1": () =>
    import("./lessons/Lesson_2_2_1_Liniowe/Lesson_index"),
  "2_2_2": () =>
    import("./lessons/Lesson_2_2_2_Kwadratowe/Lesson_index"),
  "2_2_3": () =>
    import("./lessons/Lesson_2_2_3_Wymierne/Lesson_index"),
  "2_2_4": () =>
    import("./lessons/Lesson_2_2_4_WartoscBezwzgledna/Lesson_index"),
  "2_2_5": () =>
    import("./lessons/Lesson_2_2_5_RownaniaWielomianowe/Lesson_index"),
  "2_2_6": () =>
    import("./lessons/Lesson_2_2_6_WartoscBezwzglednaRozszerzenie/Lesson_index"),
  "2_2": () =>
    import("./lessons/Lesson_2_2_Quiz/FinalQuiz"),

  "2_6_1": () =>
    import("./lessons/Lesson_2_6_1_PodstawianieDoWzorow/Lesson_index"),
  "2_6_2": () =>
    import("./lessons/Lesson_2_6_2_PrzeksztalcanieWzorow/Lesson_index"),
  "2_6_3": () =>
    import("./lessons/Lesson_2_6_3_PredkoscDrogaCzas/Lesson_index"),

  "2_3_1": () =>
    import("./lessons/Lesson_2_3_1_Liniowe/Lesson_index"),
  "2_3_2": () =>
    import("./lessons/Lesson_2_3_2_Kwadratowe/Lesson_index"),
  "2_3_3": () =>
    import("./lessons/Lesson_2_3_3_WartoscBezwzgledna/Lesson_index"),
  "2_3_4": () =>
    import("./lessons/Lesson_2_3_4_WartoscBezwzglednaRozszerzenie/Lesson_index"),
  "2_3": () =>
    import("./lessons/Lesson_2_3_Quiz/FinalQuiz"),

  "2_4_1": () =>
    import("./lessons/Lesson_2_4_1_Podstawianie/Lesson_index"),
  "2_4_2": () =>
    import("./lessons/Lesson_2_4_2_Wspolczynniki/Lesson_index"),
  "2_4_3": () =>
    import("./lessons/Lesson_2_4_3_LinioweKwadratowe/Lesson_index"),
  "2_4": () =>
    import("./lessons/Lesson_2_4_Quiz/FinalQuiz"),

  "2_5_1": () =>
    import("./lessons/Lesson_2_5_1_Uzupelniajace/Lesson_index"),
  "2_5_2": () =>
    import("./lessons/Lesson_2_5_2_Zamkniete/Lesson_index"),
  "2_5_3": () =>
    import("./lessons/Lesson_2_5_3_Otwarte/Lesson_index"),
  "2_5_4": () =>
    import("./lessons/Lesson_2_5_4_Rozszerzenie/Lesson_index"),
  "2_5_5": () =>
    import("./lessons/Lesson_2_5_5_E8Zamkniete/Lesson_index"),
  "2_5_6": () =>
    import("./lessons/Lesson_2_5_6_E8Otwarte/Lesson_index"),

  // III. Funkcje
  "3_1_1": () =>
    import("./lessons/Lesson_3_1_1_Definicja/Lesson_index"),
  "3_1_2": () =>
    import("./lessons/Lesson_3_1_2_Monotonicznosc/Lesson_index"),
  "3_1_3": () =>
    import("./lessons/Lesson_3_1_3_DziedzinaZbior/Lesson_index"),
  "3_1_4": () =>
    import("./lessons/Lesson_3_1_4_MiejscaMonotonicznosc/Lesson_index"),
  "3_1_5": () =>
    import("./lessons/Lesson_3_1_5_FunkcjeSzczegolne/Lesson_index"),
  "3_1": () =>
    import("./lessons/Lesson_3_1_Quiz/FinalQuiz"),

  "3_8_1": () =>
    import("./lessons/Lesson_7_1_5_Wektory/Lesson_index"),
  "3_8_2": () =>
    import("./lessons/Lesson_3_8_2_PrzesunieciaWykresu/Lesson_index"),
  "3_8_3": () =>
    import("./lessons/Lesson_3_8_3_SymetrieWykresu/Lesson_index"),
  "3_8_4": () =>
    import("./lessons/Lesson_3_8_4_WartoscBezwzgledna/Lesson_index"),
  "3_8_5": () =>
    import("./lessons/Lesson_3_8_5_SkalowanieWykresu/Lesson_index"),
  "3_8": () =>
    import("./lessons/Lesson_3_8_Quiz/Lesson_index"),

  "3_2_1": () =>
    import("./lessons/Lesson_3_2_1_PostacKierunkowa/Lesson_index"),
  "3_2_2": () =>
    import("./lessons/Lesson_3_2_2_Wykres/Lesson_index"),
  "3_2_3": () =>
    import("./lessons/Lesson_3_2_3_ZadaniaTekstowe/Lesson_index"),
  "3_2": () =>
    import("./lessons/Lesson_3_2_Quiz/FinalQuiz"),

  "3_3_1": () =>
    import("./lessons/Lesson_3_3_1_Ogolna/Lesson_index"),
  "3_3_2": () =>
    import("./lessons/Lesson_3_3_2_Kanoniczna/Lesson_index"),
  "3_3_3": () =>
    import("./lessons/Lesson_3_3_3_Iloczynowa/Lesson_index"),
  "3_3_4": () =>
    import("./lessons/Lesson_3_3_4_RownaniaKwadratowe/Lesson_index"),
  "3_3_5": () =>
    import("./lessons/Lesson_3_3_5_NierownosciKwadratowe/Lesson_index"),
  "3_3_6": () =>
    import("./lessons/Lesson_3_3_6_Zastosowania/Lesson_index"),
  "3_3_7": () =>
    import("./lessons/Lesson_3_3_7_ParametrVieta/Lesson_index"),
  "3_3": () =>
    import("./lessons/Lesson_3_3_Quiz/FinalQuiz"),

  "3_4_1": () =>
    import("./lessons/Lesson_3_4_1_Definicja/Lesson_index"),
  "3_4_2": () =>
    import("./lessons/Lesson_3_4_2_Asymptoty/Lesson_index"),
  "3_4_3": () =>
    import("./lessons/Lesson_3_4_3_MiejscaZerowe/Lesson_index"),
  "3_4": () =>
    import("./lessons/Lesson_3_4_Quiz/FinalQuiz"),

  "3_5_1": () =>
    import("./lessons/Lesson_3_5_1_Wykladnicza/Lesson_index"),
  "3_5_2": () =>
    import("./lessons/Lesson_3_5_2_Logarytmiczna/Lesson_index"),
  "3_5_3": () =>
    import("./lessons/Lesson_3_5_3_Zwiazki/Lesson_index"),
  "3_5": () =>
    import("./lessons/Lesson_3_5_Quiz/FinalQuiz"),

  "3_6_1": () =>
    import("./lessons/Lesson_3_6_1_Uzupelniajace/Lesson_index"),
  "3_6_2": () =>
    import("./lessons/Lesson_3_6_2_Zamkniete/Lesson_index"),
  "3_6_3": () =>
    import("./lessons/Lesson_3_6_3_Otwarte/Lesson_index"),
  "3_6_4": () =>
    import("./lessons/Lesson_3_6_4_Rozszerzenie/Lesson_index"),

  "3_7_1": () =>
    import("./lessons/Lesson_3_7_1_Pochodna/Lesson_index"),
  "3_7_2": () =>
    import("./lessons/Lesson_3_7_2_Styczna/Lesson_index"),
  "3_7_3": () =>
    import("./lessons/Lesson_3_7_3_Ekstrema/Lesson_index"),
  "3_7_4": () =>
    import("./lessons/Lesson_3_7_4_Optymalizacja/Lesson_index"),
  "3_7": () =>
    import("./lessons/Lesson_3_7_Quiz/FinalQuiz"),

  // IV. Ciągi
  "4_1_1": () =>
    import("./lessons/Lesson_4_1_1_Definicja/Lesson_index"),
  "4_1_2": () =>
    import("./lessons/Lesson_4_1_2_Monotonicznosc/Lesson_index"),
  "4_1_3": () =>
    import("./lessons/Lesson_4_1_3_Rekurencyjny/Lesson_index"),
  "4_1": () =>
    import("./lessons/Lesson_4_1_Quiz/FinalQuiz"),

  "4_2_1": () =>
    import("./lessons/Lesson_4_2_1_Definicja/Lesson_index"),
  "4_2_2": () =>
    import("./lessons/Lesson_4_2_2_Suma/Lesson_index"),
  "4_2_3": () =>
    import("./lessons/Lesson_4_2_3_ZadaniaTekstowe/Lesson_index"),
  "4_2": () =>
    import("./lessons/Lesson_4_2_Quiz/FinalQuiz"),

  "4_3_1": () =>
    import("./lessons/Lesson_4_3_1_Definicja/Lesson_index"),
  "4_3_2": () =>
    import("./lessons/Lesson_4_3_2_Suma/Lesson_index"),
  "4_3_3": () =>
    import("./lessons/Lesson_4_3_3_ProcentSkładany/Lesson_index"),
  "4_3_4": () =>
    import("./lessons/Lesson_4_3_4_ZadaniaTekstowe/Lesson_index"),
  "4_3": () =>
    import("./lessons/Lesson_4_3_Quiz/FinalQuiz"),

  "4_4_1": () =>
    import("./lessons/Lesson_4_4_1_Uzupelniajace/Lesson_index"),
  "4_4_2": () =>
    import("./lessons/Lesson_4_4_2_Zamkniete/Lesson_index"),
  "4_4_3": () =>
    import("./lessons/Lesson_4_4_3_Otwarte/Lesson_index"),

  // V. Trygonometria
  "5_1_1": () =>
    import("./lessons/Lesson_5_1_1_DefinicjeTrojkat/Lesson_index"),
  "5_1_2": () =>
    import("./lessons/Lesson_5_1_2_WartosciKatow/Lesson_index"),

  // 👉 nowe podtematy (ID 4 i 5, kolejność między 2 a 3)
  "5_1_4": () =>
    import("./lessons/Lesson_5_1_4_TozsamosciTrojkat/Lesson_index"),
  "5_1_5": () =>
    import("./lessons/Lesson_5_1_5_RozwiazywanieTrojkata/Lesson_index"),

  // istniejące zastosowania zostają pod ID 5_1_3
  "5_1_3": () =>
    import("./lessons/Lesson_5_1_3_Zastosowania/Lesson_index"),
  "5_1": () =>
    import("./lessons/Lesson_5_1_Quiz/FinalQuiz"),


  "5_2_1": () =>
    import("./lessons/Lesson_5_2_1_DefinicjaUklad/Lesson_index"),
  "5_2_2": () =>
    import("./lessons/Lesson_5_2_2_WzoryRedukcyjne/Lesson_index"),
  "5_2_3": () =>
    import("./lessons/Lesson_5_2_3_Tozsamosci/Lesson_index"),
  "5_2": () =>
    import("./lessons/Lesson_5_2_Quiz/FinalQuiz"),

  "5_3_1": () =>
    import("./lessons/Lesson_5_3_1_RownaniaTrygonometryczneCz1/Lesson_index"),
  "5_3_2": () =>
    import("./lessons/Lesson_5_3_2_RownaniaTrygonometryczneCz2/Lesson_index"),

  "5_4_1": () =>
    import("./lessons/Lesson_5_4_1_Uzupelniajace/Lesson_index"),
  "5_4_2": () =>
    import("./lessons/Lesson_5_4_2_Zamkniete/Lesson_index"),
  "5_4_3": () =>
    import("./lessons/Lesson_5_4_3_Otwarte/Lesson_index"),
  "5_4_4": () =>
  import("./lessons/Lesson_5_4_4_Rozszerzenie/Lesson_index"),

  // VI. Planimetria
  "6_1_1": () =>
    import("./lessons/Lesson_6_1_1_Wlasnosci/Lesson_index"),
  "6_1_2": () =>
    import("./lessons/Lesson_6_1_2_Pola/Lesson_index"),
  "6_1_3": () =>
    import("./lessons/Lesson_6_1_3_Promienie/Lesson_index"),
  "6_1_4": () =>
    import("./lessons/Lesson_6_1_4_Prostokatny/Lesson_index"),
  "6_1_5": () =>
    import("./lessons/Lesson_6_1_5_Rownoboczny/Lesson_index"),
  "6_1_6": () =>
    import("./lessons/Lesson_6_1_6_KatyWTrojkatach/Lesson_index"),
  "6_1_7": () =>
    import("./lessons/Lesson_6_1_7_TalesPodobienstwo/Lesson_index"),
  "6_1_8": () =>
    import("./lessons/Lesson_6_1_8_Sinusy/Lesson_index"),
  "6_1_9": () =>
    import("./lessons/Lesson_6_1_9_Cosinusy/Lesson_index"),
  "6_1": () =>
    import("./lessons/Lesson_6_1_Quiz/FinalQuiz"),

  "6_2_1": () =>
    import("./lessons/Lesson_6_2_1_ProstokatyKwadraty/Lesson_index"),
  "6_2_2": () =>
    import("./lessons/Lesson_6_2_2_RownoleglobokiRomb/Lesson_index"),
  "6_2_3": () =>
    import("./lessons/Lesson_6_2_3_Trapezy/Lesson_index"),
  "6_2_4": () =>
    import("./lessons/Lesson_6_2_4_KatyWCzworokatach/Lesson_index"),
  "6_2": () =>
    import("./lessons/Lesson_6_2_Quiz/FinalQuiz"),

  "6_3_1": () =>
    import("./lessons/Lesson_6_3_1_OkragKolo_Elementy/Lesson_index"),
  "6_3_2": () =>
    import("./lessons/Lesson_6_3_2_OkragKolo_KatyStyczne/Lesson_index"),
  "6_3_3": () =>
    import("./lessons/Lesson_6_3_3_OkragKolo_PotegaPunktu/Lesson_index"),
  "6_3": () =>
    import("./lessons/Lesson_6_3_Quiz/FinalQuiz"),

  "6_4_1": () =>
    import("./lessons/Lesson_6_4_1_Uzupelniajace/Lesson_index"),
  "6_4_2": () =>
    import("./lessons/Lesson_6_4_2_Zamkniete/Lesson_index"),
  "6_4_3": () =>
    import("./lessons/Lesson_6_4_3_Otwarte/Lesson_index"),
  "6_4_4": () =>
    import("./lessons/Lesson_6_4_4_E8Otwarte/Lesson_index"),
  "6_4_5": () =>
    import("./lessons/Lesson_6_4_5_E8Zamkniete/Lesson_index"),
  "6_5_4": () =>
    import("./lessons/Lesson_6_5_4_JednostkiIZamianaJednostek/Lesson_index"),

  "6_5_1": () =>
    import("./lessons/Lesson_6_5_1_Skala/Lesson_index"),
  "6_5_2": () =>
    import("./lessons/Lesson_6_5_2_PodobienstwoFigur/Lesson_index"),
  "6_5_3": () =>
    import("./lessons/Lesson_6_5_3_StosunekPol/Lesson_index"),
  "6_5": () =>
    import("./lessons/Lesson_6_5_Quiz/FinalQuiz"),

  "6_6_1": () =>
    import("./lessons/Lesson_6_6_1_ZaleznosciMiedzyKatami/Lesson_index"),
  "6_6_2": () =>
    import("./lessons/Lesson_6_1_6_KatyWTrojkatach/Lesson_index"),
  "6_6_3": () =>
    import("./lessons/Lesson_6_2_4_KatyWCzworokatach/Lesson_index"),
  "6_6_4": () =>
    import("./lessons/Lesson_6_3_2_OkragKolo_KatyStyczne/Lesson_index"),
  "6_6": () =>
    import("./lessons/Lesson_6_6_Quiz/FinalQuiz"),

  // VII. Geometria analityczna
  "7_1_1": () =>
    import("./lessons/Lesson_7_1_1_Wspolrzedne/Lesson_index"),
  "7_1_2": () =>
    import("./lessons/Lesson_7_1_2_Odleglosc/Lesson_index"),
  "7_1_3": () =>
    import("./lessons/Lesson_7_1_3_Srodek/Lesson_index"),
  "7_1_4": () =>
    import("./lessons/Lesson_7_1_4_Symetria/Lesson_index"),
  "7_1_5": () =>
    import("./lessons/Lesson_7_1_5_Wektory/Lesson_index"),
  "7_1": () =>
    import("./lessons/Lesson_7_1_Quiz/FinalQuiz"),
  "7_2_1": () =>
    import("./lessons/Lesson_7_2_1_Kierunkowa/Lesson_index"),
  "7_2_2": () =>
    import("./lessons/Lesson_7_2_2_Ogolna/Lesson_index"),
  "7_2_3": () =>
    import("./lessons/Lesson_7_2_3_Polozenie/Lesson_index"),
  "7_2": () =>
    import("./lessons/Lesson_7_2_Quiz/FinalQuiz"),

  "7_3_1": () =>
    import("./lessons/Lesson_7_3_1_Kanoniczna/Lesson_index"),
  "7_3_2": () =>
    import("./lessons/Lesson_7_3_2_Ogolna/Lesson_index"),
  "7_3_3": () =>
    import("./lessons/Lesson_7_3_3_Polozenie/Lesson_index"),
  "7_3": () =>
    import("./lessons/Lesson_7_3_Quiz/FinalQuiz"),

  "7_4_1": () =>
    import("./lessons/Lesson_7_4_1_Trojkaty/Lesson_index"),

  "7_5_1": () =>
    import("./lessons/Lesson_7_5_1_Uzupelniajace/Lesson_index"),
  "7_5_2": () =>
    import("./lessons/Lesson_7_5_2_Zamkniete/Lesson_index"),
  "7_5_3": () =>
    import("./lessons/Lesson_7_5_3_Otwarte/Lesson_index"),
  "7_5_4": () =>
    import("./lessons/Lesson_7_5_4_E8Zamkniete/Lesson_index"),

  // VIII. Stereometria
  "8_1_1": () =>
    import("./lessons/Lesson_8_1_1_Wlasnosci/Lesson_index"),
  "8_1_2": () =>
    import("./lessons/Lesson_8_1_2_Pole/Lesson_index"),
  "8_1_3": () =>
    import("./lessons/Lesson_8_1_3_Objetosc/Lesson_index"),
  "8_1_4": () =>
    import("./lessons/Lesson_8_1_4_Przekroje/Lesson_index"),
  "8_1": () =>
    import("./lessons/Lesson_8_1_Quiz/FinalQuiz"),

  "8_2_1": () =>
    import("./lessons/Lesson_8_2_1_Wlasnosci/Lesson_index"),
  "8_2_2": () =>
    import("./lessons/Lesson_8_2_2_Pole/Lesson_index"),
  "8_2_3": () =>
    import("./lessons/Lesson_8_2_3_Objetosc/Lesson_index"),
  "8_2_4": () =>
    import("./lessons/Lesson_8_2_4_Przekroje/Lesson_index"),
  "8_2": () =>
    import("./lessons/Lesson_8_2_Quiz/FinalQuiz"),

  "8_3_1": () =>
    import("./lessons/Lesson_8_3_1_Walec/Lesson_index"),
  "8_3_2": () =>
    import("./lessons/Lesson_8_3_2_Stozek/Lesson_index"),
  "8_3_3": () =>
    import("./lessons/Lesson_8_3_3_Kula/Lesson_index"),
  "8_3": () =>
    import("./lessons/Lesson_8_3_Quiz/FinalQuiz"),

  "8_4_1": () =>
    import("./lessons/Lesson_8_4_1_Uzupelniajace/Lesson_index"),
  "8_4_2": () =>
    import("./lessons/Lesson_8_4_2_Zamkniete/Lesson_index"),
  "8_4_3": () =>
    import("./lessons/Lesson_8_4_3_Otwarte/Lesson_index"),
  "8_4_4": () =>
    import("./lessons/Lesson_8_4_4_E8Otwarte/Lesson_index"),
  "8_4_5": () =>
    import("./lessons/Lesson_8_4_5_E8Zamkniete/Lesson_index"),

  // IX. Prawdopodobieństwo i statystyka
  "9_1_1": () =>
    import("./lessons/Lesson_9_1_1_Podstawy/Lesson_index"),
  "9_1_2": () =>
    import("./lessons/Lesson_9_1_2_Permutacje/Lesson_index"),
  "9_1_3": () =>
    import("./lessons/Lesson_9_1_3_Wariacje/Lesson_index"),
  "9_1_4": () =>
    import("./lessons/Lesson_9_1_4_Kombinacje/Lesson_index"),
  "9_1": () =>
    import("./lessons/Lesson_9_1_Quiz/FinalQuiz"),

  "9_2_1": () =>
    import("./lessons/Lesson_9_2_1_Podstawy/Lesson_index"),
  "9_2_2": () =>
    import("./lessons/Lesson_9_2_2_ZastosowaniaKombinatoryki/Lesson_index"),
  "9_2_3": () =>
    import("./lessons/Lesson_9_2_3_Zdarzenia/Lesson_index"),
  "9_2": () =>
    import("./lessons/Lesson_9_2_Quiz/FinalQuiz"),

  "9_3_1": () =>
    import("./lessons/Lesson_9_3_1_Srednie/Lesson_index"),
  "9_3_2": () =>
    import("./lessons/Lesson_9_3_2_PolozenieZmiennosc/Lesson_index"),
  "9_3_3": () =>
    import("./lessons/Lesson_9_3_3_OdczytywanieDiagramow/Lesson_index"),
  "9_3": () =>
    import("./lessons/Lesson_9_3_Quiz/FinalQuiz"),

  "9_4_1": () =>
    import("./lessons/Lesson_9_4_1_Uzupelniajace/Lesson_index"),
  "9_4_2": () =>
    import("./lessons/Lesson_9_4_2_Zamkniete/Lesson_index"),
  "9_4_3": () =>
    import("./lessons/Lesson_9_4_3_Otwarte/Lesson_index"),
  "9_4_4": () =>
    import("./lessons/Lesson_9_4_4_Rozszerzenie/Lesson_index"),
  "9_4_5": () =>
    import("./lessons/Lesson_9_4_5_E8Zamkniete/Lesson_index"),

  // X. Dowody matematyczne
  "10_1_1": () =>
    import("./lessons/Lesson_10_1_1_Podzielnosc/Lesson_index"),
  "10_1_2": () =>
    import("./lessons/Lesson_10_1_2_RowosciNierownosci/Lesson_index"),
  "10_1_3": () =>
    import("./lessons/Lesson_10_1_3_Indukcja/Lesson_index"),
  "10_1": () =>
    import("./lessons/Lesson_10_1_Quiz/FinalQuiz"),

  "10_2_1": () =>
    import("./lessons/Lesson_10_2_1_PlanimetriaFigury/Lesson_index"),
  "10_2_2": () =>
    import("./lessons/Lesson_10_2_2_PlanimetriaKaty/Lesson_index"),
  "10_2_3": () =>
    import("./lessons/Lesson_10_2_3_Stereometria/Lesson_index"),
  "10_2": () =>
    import("./lessons/Lesson_10_2_Quiz/FinalQuiz"),

  "10_3_1": () =>
    import("./lessons/Lesson_10_3_1_Uzupelniajace/Lesson_index"),
  "10_3_2": () =>
    import("./lessons/Lesson_10_3_2_Zamkniete/Lesson_index"),
  "10_3_3": () =>
    import("./lessons/Lesson_10_3_3_Otwarte/Lesson_index"),

  // I. Liczby i działania -> Ułamki dziesiętne
  "1_11_2": () =>
    import(
      "./lessons/Lesson_11_1_1_DodawanieOdejmowanieUlamkowDziesietnych/Lesson_index"
    ),
  "1_11_3": () =>
    import("./lessons/Lesson_11_1_2_MnozenieUlamkowDziesietnych/Lesson_index"),
  "1_11_4": () =>
    import("./lessons/Lesson_11_1_3_DzielenieUlamkowDziesietnych/Lesson_index"),
  "1_11_6": () =>
    import("./lessons/Lesson_11_1_4_SzacowanieUlamkowDziesietnych/Lesson_index"),

  // XI. Szkoła podstawowa (stare ID, kompatybilność)
  "11_1_1": () =>
    import(
      "./lessons/Lesson_11_1_1_DodawanieOdejmowanieUlamkowDziesietnych/Lesson_index"
    ),
  "11_1_2": () =>
    import("./lessons/Lesson_11_1_2_MnozenieUlamkowDziesietnych/Lesson_index"),
  "11_1_3": () =>
    import("./lessons/Lesson_11_1_3_DzielenieUlamkowDziesietnych/Lesson_index"),
  "11_1_4": () =>
    import("./lessons/Lesson_11_1_4_SzacowanieUlamkowDziesietnych/Lesson_index"),
};
